module.exports = __webpack_public_path__ + "images/emoji/dollar.6bec0a878baa4eb06070.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dollar.png
// module id = K4XI
// module chunks = 14